<template>
  <div class="popularity-avatars">
    <div class="popularity-avatars__layout">
      <img :src="avatar" class="popularity-avatars__image" :alt="description">
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopularityAvatars',
  data () {
    return {
      avatar: require(`@/assets/popularity/pk-${this.index + 1}.jpg`)
    }
  },
  props: {
    index: { type: Number, default: 0 },
    description: { type: String, default: '' }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .popularity-avatars {
    position: relative;

    &__layout {
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 39.47%;
    }

    &__image {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: auto;
    }
  }
</style>
